import { render, staticRenderFns } from "./BaseRoundedButton.vue?vue&type=template&id=b02349de&scoped=true&"
import script from "./BaseRoundedButton.vue?vue&type=script&lang=js&"
export * from "./BaseRoundedButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseRoundedButton.vue?vue&type=style&index=0&id=b02349de&prod&lang=scss&scoped=true&"
import style1 from "./BaseRoundedButton.vue?vue&type=style&index=1&id=b02349de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02349de",
  null
  
)

export default component.exports